
import css from 'styled-jsx/css';

const styles = css.global`/* @styled-jsx=global */

footer {
  font-size: 1rem;
  font-family: $fontTTNormsPro;
  font-weight: 400;

  @include media-query(desktopLg) {
    padding: 0;
    margin: 0 auto;
  }
}

.footer {
  &__link {
    @include focusable;
    display: inline-block;
    color: $mvp-slate;
    text-decoration: none;
    position: relative;
    outline: none;
    padding: 6px 0;

    span {
      color: inherit;
    }

    &:hover {
      text-decoration: underline;
    }

    &--blog {
      > a {
        @include focusable;
      }

      &:hover {
        text-decoration: none;
      }
    }
  }
}

.content-wrapper {
  display: grid;
  grid-template-columns: 12fr;
  grid-column: 1/-1;
  margin: 2rem auto;

  @include media-query(tablet) {
    grid-template-columns: 8fr 4fr;
    margin: 2.5rem auto;
  }

  @include media-query(desktop) {
    grid-template-columns: 9fr 3fr;
    margin: 3rem auto;
  }
}

.primary-links {
  column-count: 1;

  @media (min-width: 25em) {
    column-count: 2;
  }
  @include media-query(laptop) {
    column-count: 3;
  }
  @include media-query(desktop) {
    column-count: 4;
  }

  &__list-item {
    width: 100%;
    break-inside: avoid;
    padding-bottom: 2.25rem;
  }
}

// Prevent column items wrapping for Firefox.
@supports (page-break-inside: avoid) {
  .primary-links__list-item {
    page-break-inside: avoid;
    overflow: hidden;
  }
}

.secondary-links {
  grid-row-start: 4;
  display: flex;

  &__list-item {
    font-weight: 700;
  }
  @include media-query(mobile) {
    flex-wrap: wrap;
    grid-gap: 2rem;
    padding-top: 2rem;
    border-top: 1px solid $mvp-stone;
    grid-gap: 1.2rem;
    grid-row-gap: 1.563rem;
    padding-bottom: 2.5rem;
  }

  @include media-query(tablet) {
    padding: 1.5rem 0;
    grid-column: 1/-1;

    &__list-item {
      &:nth-child(n + 2) {
        .secondary-links {
          &__link {
            padding: 0 0.938rem;
          }
        }
      }
    }
  }

  &__link {
    @include focusable($inlineOffset: 0, $blockOffset: 0);

    color: $mvp-slate;
    text-decoration: none;

    &:hover,
    &:focus {
      outline: none;
      text-decoration: underline;
    }

    @include media-query(tablet) {
      padding-right: 0.938rem;
    }
  }
}

.extra-content {
  grid-row-start: 3;
  grid-column: span 2;

  @include media-query(mobile) {
    padding: 2rem 0;
  }
}

.blog-content {
  border-top: 1px solid $mvp-stone;
  border-bottom: 1px solid $mvp-stone;

  @include media-query(mobile) {
    grid-row-start: 2;
    padding: 2rem 0;
  }

  @include media-query(tablet) {
    border: none;
    padding-top: 0;
  }
}
`;

export default styles;